
const Payment = () => {
  return (
    <div>payment</div>
  )
}

export default Payment